import React, { useState, useEffect, useRef } from "react";
import emailjs from "emailjs-com"; // ✅ EmailJS SDK
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import ERPChatbot from "../../components/ERPChatbot/ERPChatbot";
import "./Contactus.css";

const Contactus = () => {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [activeFAQ, setActiveFAQ] = useState(null);
  const [errors, setErrors] = useState({});
  const formRef = useRef();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

const validateForm = (formData) => {
  let newErrors = {};

  // Name
  if (!formData.get("name").trim()) {
    newErrors.name = "Name is required";
  }
    // Email
  const email = formData.get("email").trim();
  if (!email) {
    newErrors.email = "Email is required";
  } else if (!/\S+@\S+\.\S+/.test(email)) {
    newErrors.email = "Invalid email format";
  }
  // Designation
  if (!formData.get("designation").trim()) {
    newErrors.designation = "Designation is required";
  }

  // Contact Number
  const contact = formData.get("contact").trim();
  if (!contact) {
    newErrors.contact = "Contact number is required";
  } else if (!/^[0-9]{10}$/.test(contact)) {
    newErrors.contact = "Enter a valid 10-digit contact number";
  }

  // Subject
  if (!formData.get("subject").trim()) {
    newErrors.subject = "Subject is required";
  }

  // Message
  if (!formData.get("message").trim()) {
    newErrors.message = "Message cannot be empty";
  }

  return newErrors;
};


  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData(formRef.current);
    const validationErrors = validateForm(formData);

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setLoading(false);
      return;
    }

    setErrors({});

    emailjs
      .sendForm(
        "service_aikb6s9", // 🔹 your EmailJS Service ID
        "template_p11arfk", // 🔹 your EmailJS Template ID
        formRef.current,
        // "DTg29tM0_5_m0RPQc" // 🔹 your EmailJS Public Key
      )
      .then(
        (result) => {
          console.log(result.text);
          setLoading(false);
          setSubmitted(true);
          formRef.current.reset(); // ✅ clear form after success
          setTimeout(() => setSubmitted(false), 4000);
        },
        (error) => {
          console.error(error.text);
          setLoading(false);
          alert("❌ Failed to send message. Please try again later.");
        }
      );
  };

  const toggleFAQ = (index) => {
    setActiveFAQ(activeFAQ === index ? null : index);
  };

  return (
    <>
      {/* ===== Header OUTSIDE styles ===== */}
      <Header />

      {/* ===== Contact Page Wrapper ===== */}
      <div className="contact-page">
        {/* ===== Hero Section ===== */}
        <section className="contact-hero">
          <div className="contact-overlay">
            <h1>Let’s Connect 🤝</h1>
            <p>We’d love to hear from you — drop us a message anytime!</p>
          </div>
        </section>

        {/* ===== Contact Section ===== */}
        <section className="contact-content">
          {/* Left: Form */}
          <div className="contact-form">
            <h2>Send us a Message</h2>
          <form ref={formRef} onSubmit={handleSubmit}>
      {/* Name */}
      <div className="input-group">
        <input
          type="text"
          name="name"
          placeholder=" "
          className={errors.name ? "error-input" : ""}
          required
        />
        <label>Your Name</label>
        {errors.name && <span className="error">{errors.name}</span>}
      </div>

 {/* Email */}
      <div className="input-group">
        <input
          type="email"
          name="email"
          placeholder=" "
          className={errors.email ? "error-input" : ""}
          required
        />
        <label>Your Email</label>
        {errors.email && <span className="error">{errors.email}</span>}
      </div>

      {/* Designation */}
      <div className="input-group">
        <input
          type="text"
          name="designation"
          placeholder=" "
          className={errors.designation ? "error-input" : ""}
          required
        />
        <label>Your Designation</label>
        {errors.designation && (
          <span className="error">{errors.designation}</span>
        )}
      </div>

      {/* Contact Number */}
      <div className="input-group">
        <input
          type="tel"
          name="contact"
          placeholder=" "
          className={errors.contact ? "error-input" : ""}
          required
          pattern="[0-9]{10}"
          maxLength="10"
        />
        <label>Contact Number</label>
        {errors.contact && <span className="error">{errors.contact}</span>}
      </div>

     

      {/* Subject */}
      <div className="input-group">
        <input
          type="text"
          name="subject"
          placeholder=" "
          className={errors.subject ? "error-input" : ""}
          required
        />
        <label>Subject</label>
        {errors.subject && <span className="error">{errors.subject}</span>}
      </div>

      {/* Message */}
      <div className="input-group">
        <textarea
          name="message"
          rows="5"
          placeholder=" "
          className={errors.message ? "error-input" : ""}
          required
        ></textarea>
        <label>Your Message</label>
        {errors.message && <span className="error">{errors.message}</span>}
      </div>

      {/* Submit Button */}
      <button type="submit" disabled={loading}>
        {loading ? "Sending..." : "Send Message"}
      </button>
    </form>

            {submitted && (
              <div className="success-msg">✅ Message Sent Successfully!</div>
            )}
          </div>

          {/* Right: Info */}
          <div className="contact-info">
            <h2>Get in Touch</h2>
            <div className="info-cards">
              <div className="info-card">
                <span>📍</span>
                <p>Madurai, Tamil Nadu, India</p>
              </div>
              <div className="info-card">
                <span>📞</span>
                <p>+91 9884164415</p>
              </div>
              <div className="info-card">
                <span>✉️</span>
                <p>contact@larcherp.com</p>
              </div>
            </div>

            <div className="working-hours">
              <h3>🕒 Working Hours</h3>
              <p>Mon - Fri: 9:00 AM - 6:00 PM</p>
              <p>Sat: 9:00 AM - 6:00 PM</p>
              <p>Sun: Closed</p>
            </div>

            <div className="social-links">
              <a
                href="https://linkedin.com/company/larcherp"
                target="_blank"
                rel="noreferrer"
              >
                LinkedIn
              </a>
              <a
                href="https://instagram.com/larch_technologies"
                target="_blank"
                rel="noreferrer"
              >
                Instagram
              </a>
              <a href="https://twitter.com" target="_blank" rel="noreferrer">
                Twitter
              </a>
            </div>
          </div>
        </section>

        {/* ===== Stats Section ===== */}
        <section className="stats-section">
          <div className="stat">
            <h2>10+</h2>
            <p>Happy Clients</p>
          </div>
          <div className="stat">
            <h2>10+</h2>
            <p>Projects Completed</p>
          </div>
          <div className="stat">
            <h2>15+</h2>
            <p>Team Members</p>
          </div>
        </section>

        {/* ===== FAQ Section ===== */}
        <section className="faq-section">
          <h2>Frequently Asked Questions</h2>
          <div className="faq-item">
            <button onClick={() => toggleFAQ(1)}>
              How can I contact your team?{" "}
              <span>{activeFAQ === 1 ? "-" : "+"}</span>
            </button>
            {activeFAQ === 1 && (
              <p>
                You can reach us via the contact form, email, or phone number
                listed above.
              </p>
            )}
          </div>
          <div className="faq-item">
            <button onClick={() => toggleFAQ(2)}>
              Where is your office located?{" "}
              <span>{activeFAQ === 2 ? "-" : "+"}</span>
            </button>
            {activeFAQ === 2 && (
              <p>Our office is in Madurai, Tamil Nadu, India.</p>
            )}
          </div>
          <div className="faq-item">
            <button onClick={() => toggleFAQ(3)}>
              Do you offer internships?{" "}
              <span>{activeFAQ === 3 ? "-" : "+"}</span>
            </button>
            {activeFAQ === 3 && (
              <p>
                Yes, we regularly onboard interns. Please check our Careers page
                for updates.
              </p>
            )}
          </div>
        </section>

        {/* ===== Map Section ===== */}
        <section className="map-section">
          <h2>📍 Find Us Here</h2>
          <iframe
            title="Google Map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3912.210380127!2d78.1198!3d9.9252!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b00c582e0e6e5b1%3A0xa40121e93c44a9d9!2sMadurai%2C%20Tamil%20Nadu!5e0!3m2!1sen!2sin!4v1678964312345"
            width="100%"
            height="400"
            style={{ border: "0" }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </section>
      </div>

      {/* ===== Footer OUTSIDE styles ===== */}
      <Footer />
      <ERPChatbot />
    </>
  );
};

export default Contactus;
